import PropTypes from 'prop-types';

const LabelText = ({ label, message, failureMessage, styledMessage }) => (
  <span>
    {styledMessage ? (
      <span>
        <span>{label}</span>
        <span className="label__message">{failureMessage || message}</span>
      </span>
    ) : (
      failureMessage || message || label
    )}
  </span>
);

LabelText.propTypes = {
  label: PropTypes.string,
  message: PropTypes.string,
  failureMessage: PropTypes.string,
  styledMessage: PropTypes.bool,
};

LabelText.defaultProps = {
  label: '',
  message: '',
  failureMessage: '',
  styledMessage: false,
};

export default LabelText;
